"use client";

import Autoplay from "embla-carousel-autoplay";
import Image from "next/image";

import { FadeInIntersection } from "@/common/components";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/common/components/carousel";
import { SectionHeading } from "@/common/components/section";
import { MigrationLink } from "@/common/components-2/migration-link";

import { getCarouselCardClass, getMediaAboutUsSectionClass } from "./media-about-us-section.styles";
import type { MediaAboutUsSectionProps } from "./media-about-us-section.types";

export function MediaAboutUsSection({ className, heading, items, ...props }: MediaAboutUsSectionProps) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- To fix; add type to `autoplay`
  const autoplay = Autoplay({ delay: 3000, stopOnFocusIn: true, stopOnInteraction: true, stopOnMouseEnter: true });

  return (
    <section className={getMediaAboutUsSectionClass({ className })} {...props}>
      <FadeInIntersection threshold={0.3} className="container md:max-w-[90%]">
        <SectionHeading size="lg">
          <h2>{heading}</h2>
        </SectionHeading>
        <div className="mx-auto max-w-[80%] lg:max-w-[1400px]">
          <Carousel
            className="mt-20 w-full"
            plugins={[autoplay]}
            opts={{
              align: "start",
              inViewThreshold: 0.75,
            }}
          >
            <CarouselContent className="items-center">
              {items.map(({ image, link }) => (
                <CarouselItem key={link} className={getCarouselCardClass()}>
                  <MigrationLink
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:-translate-y-1 block duration-200 ease-out"
                  >
                    <Image
                      src={image.url}
                      alt={image.title}
                      width={300}
                      height={300}
                      className="mx-auto max-w-32 lg:max-w-40"
                    />
                  </MigrationLink>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious />
            <CarouselNext />
          </Carousel>
        </div>
      </FadeInIntersection>
    </section>
  );
}
